import { LOCK_DOOR, UNLOCK_DOOR } from './constants';

/** Translation key of a command's label; unknown commands fall back to their raw name. */
const COMMAND_LABEL_KEYS = {
	[LOCK_DOOR]: 'oemDataModal_remote_lock',
	[UNLOCK_DOOR]: 'oemDataModal_remote_unlock',
};

export const commandLabel = (command, messages) => messages[COMMAND_LABEL_KEYS[command]] || command;

export const statusLabel = (status, messages) => messages[`oemDataModal_remote_status_${status}`] || status;

/** `row` first, without any older copy of the same id (newest-first list). */
export const prependCommand = (list, row) => [row, ...(list ?? []).filter((item) => String(item.id) !== String(row.id))];

/** `row` in place of the item with its id; the list unchanged (same reference) when absent. */
export const replaceCommand = (list, row) => {
	if (!Array.isArray(list)) return list;
	const index = list.findIndex((item) => String(item.id) === String(row.id));
	if (index === -1) return list;
	const next = [...list];
	next[index] = row;
	return next;
};

/** GraphQL errors of a `clientMutation` / `clientQuery` rejection (raw response first, then Apollo's). */
const graphQLErrorsOf = (exc) => exc?.errorData?.errors || exc?.innerError?.graphQLErrors || [];

/**
 * The backend's specific reason (CONFLICT, UNAUTHORIZED, ...) — it travels in
 * `errorInfo.reason` because the framework error codes have no CONFLICT.
 */
export const remoteCommandErrorReason = (exc) => {
	const withReason = graphQLErrorsOf(exc).find((error) => error?.errorInfo?.reason);
	return withReason?.errorInfo?.reason ?? null;
};

const ERROR_MESSAGE_KEYS = {
	CONFLICT: 'oemDataModal_remote_conflict',
	UNAUTHORIZED: 'oemDataModal_remote_notAllowed',
};

/** Translation key for a rejected send. */
export const remoteCommandErrorKey = (exc) =>
	ERROR_MESSAGE_KEYS[remoteCommandErrorReason(exc)] || 'oemDataModal_remote_failed';

/** Idempotency key for one confirmed click (`crypto.randomUUID` needs a secure context). */
export const newClientRequestId = () => {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
	const bytes = crypto.getRandomValues(new Uint8Array(16));
	bytes[6] = (bytes[6] & 0x0f) | 0x40;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;
	const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
